import * as React from "react";
import {observer} from "mobx-react-lite";
import {
    CBody1,
    CBox,
    CButton,
    CCard,
    CCardContent,
    CCircularProgress,
    CGrid,
    CH4,
    CH6,
    CTableHead,
    CTable,
    CTableRow,
    CTableCell,
    CTableBody,
    CTableContainer,
    CDialog,
    CDialogContent,
    CDialogActions,
    CDialogTitle,
    CTextField,
    CFormControlLabel,
    CCheckbox,
    CFormGroup,
    CBody2, CFormControl, CInputLabel, CSelect, CMenuItem
} from "../../components";
import {hasValue} from "../../utils/empty-check";
import {useEffect} from "react";
import {useStores} from "../../models";
import {isEmpty} from "validate.js";
import {fetchSignInMethodsForEmail} from "firebase/auth";
import {auth} from "../../firebase";
import {SelectChangeEvent} from "@mui/material";

export const Staff = observer(
    function Staff() {

        const {projectStore, businessStore, staffStore} = useStores()
        const {business} = businessStore
        const {
            projects,
        } = projectStore
        const {
            staff,
            isLoadingStaff,
            addStaff,
            getStaff,
            updateStaff,
            deleteStaff
        } = staffStore


        const [formData, setFormData] = React.useState<
            {
                name: string,
                email: string,
                role: string,
                projectIds: string[]
            }>({
            name: "",
            email: "",
            role: "editor",
            projectIds: []
        })

        const [formDataValidationMessages, setFormDataValidationMessages] = React.useState({
            name: "",
            email: "",
            projectIds: ""
        })

        const [dialog, setDialog] = React.useState<{
            isOpen: boolean,
            isAdd: boolean,
            data: any
        }>({
            isOpen: false,
            isAdd: false,
            data: null
        });

        const [updateFormData, setUpdateFormData] = React.useState<
            {
                name: string,
                role: string,
                projectIds: string[]
            }>({
            name: "",
            role: "editor",
            projectIds: []
        })

        const [updateFormDataValidationMessages, setUpdateFormDataValidationMessages] = React.useState({
            name: "",
            projectIds: ""
        })

        const [updateDialog, setUpdateDialog] = React.useState<{
            isOpen: boolean,
            isAdd: boolean,
            data: any
        }>({
            isOpen: false,
            isAdd: false,
            data: null
        });

        const [isAdding, setIsAdding] = React.useState(false)

        const [isUpdating, setIsUpdating] = React.useState(false)

        const [isDeleting, setIsDeleting] = React.useState(false)

        const [deleteDialog, setDeleteDialog] = React.useState<{
            isOpen: boolean,
            data: {
                id: string
            } | null
        }>({
            isOpen: false,
            data: null
        });

        const openAddDialog = () => {
            setFormData({
                name: "",
                email: "",
                role: "editor",
                projectIds: []
            })
            setFormDataValidationMessages({
                name: "",
                email: "",
                projectIds: ""
            })
            setDialog({
                isOpen: true,
                isAdd: true,
                data: null
            })
        }

        const closeAddDialog = () => {
            setDialog({
                isOpen: false,
                isAdd: true,
                data: null
            })
            setFormData({
                name: "",
                email: "",
                role: "editor",
                projectIds: []
            })
            setFormDataValidationMessages({
                name: "",
                email: "",
                projectIds: ""
            })
        }

        const openUpdateDialog = (item) => {
            setUpdateFormData({
                name: item.name,
                role: "editor",
                projectIds: [...item.projectIds]
            })
            setUpdateFormDataValidationMessages({
                name: "",
                projectIds: ""
            })
            setUpdateDialog({
                isOpen: true,
                isAdd: true,
                data: {
                    id: item.id,
                    name: item.name,
                    projectIds: [...item.projectIds]
                }
            })
        }

        const closeUpdateDialog = () => {
            setUpdateDialog({
                isOpen: false,
                isAdd: true,
                data: null
            })
            setUpdateFormData({
                name: "",
                role: "editor",
                projectIds: []
            })
            setUpdateFormDataValidationMessages({
                name: "",
                projectIds: ""
            })
        }

        useEffect(() => {
            if (business?.id) {
                getStaff(business.id)
            }
        }, [])

        const isValid = () => {

            let output = true

            const currentFormDataValidationMessages = {
                ...formDataValidationMessages
            }

            if (isEmpty(formData.name)) {
                currentFormDataValidationMessages.name = "Name is required."
                output = false
            }

            if (isEmpty(formData.email)) {
                currentFormDataValidationMessages.email = "Email Address is required."
                output = false
            }

            if (isEmpty(formData.projectIds) || formData.projectIds.length === 0) {
                currentFormDataValidationMessages.projectIds = "At least one project needs to be selected."
                output = false
            }

            if (!output) {
                setFormDataValidationMessages(currentFormDataValidationMessages)
            }

            return output
        }

        const isUpdateValid = () => {

            let output = true

            const currentFormDataValidationMessages = {
                ...updateFormDataValidationMessages
            }

            if (isEmpty(updateFormData.name)) {
                currentFormDataValidationMessages.name = "Name is required."
                output = false
            }

            if (isEmpty(updateFormData.projectIds) || updateFormData.projectIds.length === 0) {
                currentFormDataValidationMessages.projectIds = "At least one project needs to be selected."
                output = false
            }

            if (!output) {
                setUpdateFormDataValidationMessages(currentFormDataValidationMessages)
            }

            return output
        }


        const add = async () => {
            if(isValid()) {
                setIsAdding(true);
                const signInMethods = await fetchSignInMethodsForEmail(auth, formData.email)
                if (signInMethods.length > 0) {
                    setFormDataValidationMessages({
                        ...formDataValidationMessages,
                        email: "This email address is already taken."
                    })
                    setIsAdding(false)
                    return;
                }
                await addStaff(formData, business?.id)
                closeAddDialog();
                setIsAdding(false);
            }
        }

        const update = async () => {
            if(isUpdateValid()) {
                setIsUpdating(true);
                await updateStaff(updateDialog.data.id,updateFormData, business?.id)
                closeUpdateDialog()
                setIsUpdating(false);
            }
        }

        const onProjectCheckChanged = (event: React.ChangeEvent<HTMLInputElement>, projectId: string) => {
            if(event.target.checked) {
                if(!formData.projectIds.includes(projectId)) {
                    setFormData({
                        ...formData,
                        projectIds: [...formData.projectIds, projectId]
                    })
                }

            } else {
                if(formData.projectIds.includes(projectId)) {
                    setFormData({
                        ...formData,
                        projectIds: formData.projectIds.filter((id)=>id !== projectId)
                    })
                }
            }
        }

        const updateOnProjectCheckChanged = (event: React.ChangeEvent<HTMLInputElement>, projectId: string) => {
            if(event.target.checked) {
                if(!updateFormData.projectIds.includes(projectId)) {
                    setUpdateFormData({
                        ...updateFormData,
                        projectIds: [...updateFormData.projectIds, projectId]
                    })
                }
            } else {
                if(updateFormData.projectIds.includes(projectId)) {
                    setUpdateFormData({
                        ...updateFormData,
                        projectIds: updateFormData.projectIds.filter((id)=>id !== projectId)
                    })
                }
            }
        }

        const openDeleteDialog = (id: string | undefined) => {
            if (id) {
                setDeleteDialog({
                    isOpen: true,
                    data: {
                        id
                    }
                })
            }

        }

        const closeDeleteDialog = () => {
            setDeleteDialog({
                isOpen: false,
                data: null
            })
        }

        const submitDelete = async () => {
            setIsDeleting(true);
            await deleteStaff(deleteDialog.data?.id, business?.id);
            setIsDeleting(false)

            closeDeleteDialog();
        }


        return (
            <>
                <CGrid container spacing={2}>
                    <CGrid item xs={12}>
                        <CCard>
                            <CCardContent sx={{display: "flex", flexDirection: 'row', alignItems: 'center', py: 3}}>
                                <CH4 fontWeight={'900'}>
                                    Staff
                                </CH4>
                                <CButton sx={{ml: 2}} size="medium" variant="contained" onClick={openAddDialog}>
                                    Add New
                                </CButton>
                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={12}>
                        <CCard>
                            <CCardContent>
                                {isLoadingStaff && (
                                    <CBox
                                        sx={{
                                            width: '100%',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: 4,
                                            display: 'flex'
                                        }}>
                                        <CCircularProgress/>
                                        <CBody1 sx={{ml: 2, fontWeight: 'bold', opacity: 0.6}}>
                                            Loading Businesses ...
                                        </CBody1>
                                    </CBox>
                                )}
                                {(!isLoadingStaff && !hasValue(staff)) && <CBox>
                                    <CH6 sx={(theme) => ({fontWeight: 600, color: theme.palette.primary.light})}>No
                                        business is found...</CH6>
                                    <CBody1 sx={(theme) => ({mt: 2, mb: 2, color: theme.palette.primary.light})}>Please
                                        change the status filter or wait for new businesses to register.</CBody1>
                                </CBox>}
                                {(!isLoadingStaff && hasValue(staff)) && <CTableContainer>
                                    <CTable sx={{minWidth: 650}} aria-label="simple table">
                                        <CTableHead>
                                            <CTableRow>
                                                <CTableCell>Name</CTableCell>
                                                <CTableCell>Email</CTableCell>
                                                <CTableCell>Role</CTableCell>
                                                <CTableCell>Actions</CTableCell>
                                            </CTableRow>
                                        </CTableHead>

                                        <CTableBody>

                                            {staff?.map(item => {
                                                return (<CTableRow
                                                    key={item.id}
                                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                                >
                                                    <CTableCell component="th" scope="row">
                                                        {item.name}
                                                    </CTableCell>
                                                    <CTableCell>{item.email}</CTableCell>
                                                    <CTableCell>{item.role}</CTableCell>
                                                    <CTableCell>
                                                        {item.email !== business?.email &&
                                                            <>
                                                                <CButton size="medium" variant="contained" sx={{mr: 2}}
                                                                    onClick={() => openUpdateDialog(item)}
                                                                >
                                                                    Update
                                                                </CButton>
                                                                <CButton size="medium" variant="contained"
                                                                         color={"error"}
                                                                    onClick={() => openDeleteDialog(item.id)}
                                                                >
                                                                    Delete
                                                                </CButton>
                                                            </>
                                                        }

                                                    </CTableCell>
                                                </CTableRow>)
                                            })}


                                        </CTableBody>
                                    </CTable>
                                </CTableContainer>}

                            </CCardContent>
                        </CCard>


                    </CGrid>
                </CGrid>

                <CDialog PaperProps={{
                    style: {
                        borderRadius: 27,
                    }
                }}
                         componentsProps={{
                             backdrop: {
                                 style: {
                                     backdropFilter: "blur(3px)",
                                     backgroundColor: 'rgba(0,0,30,0.4)'
                                 }
                             },
                         }} open={dialog.isOpen} onClose={closeAddDialog} fullWidth>
                    <CDialogTitle fontWeight={"700"} sx={{mb: 2}}>Add New Staff</CDialogTitle>
                    <CDialogContent>
                        <CGrid container spacing={4}>
                            <CGrid item xs={12} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <CTextField
                                    fullWidth
                                    error={hasValue(formDataValidationMessages.name)}
                                    helperText={formDataValidationMessages.name}
                                    label="Name"
                                    variant="standard"
                                    sx={{
                                        mb: 2
                                    }}
                                    value={formData.name}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setFormData({
                                            ...formData,
                                            name: event.target.value
                                        });
                                    }}
                                />
                            </CGrid>
                            <CGrid item xs={12} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <CTextField
                                    fullWidth
                                    error={hasValue(formDataValidationMessages.email)}
                                    helperText={formDataValidationMessages.email}
                                    label="Email"
                                    variant="standard"
                                    sx={{
                                        mb: 2
                                    }}
                                    value={formData.email}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setFormData({
                                            ...formData,
                                            email: event.target.value
                                        });
                                    }}
                                />
                            </CGrid>
                            <CGrid item xs={12} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <CFormControl variant="standard" fullWidth>
                                    <CInputLabel id="role-label">Role</CInputLabel>
                                    <CSelect
                                        labelId="role-label"
                                        id="role"
                                        value={formData.role}
                                        label="Role"
                                        onChange={(event: SelectChangeEvent<unknown>) => {
                                            setFormData({
                                                ...formData,
                                                role: event.target.value as string
                                            });
                                        }}
                                    >
                                        <CMenuItem value={"owner"}>Owner</CMenuItem>
                                        <CMenuItem value={"editor"}>Editor</CMenuItem>
                                    </CSelect>
                                </CFormControl>
                            </CGrid>
                            <CGrid item xs={12} sx={{alignItems: 'center'}}>
                                <CBody1 fontWeight={"bold"} sx={{mb: 1}}>
                                    Allowed Projects:
                                </CBody1>
                                <CFormGroup>
                                    {projects?.map(project=>(
                                        <CFormControlLabel key={project.id} control={<CCheckbox
                                            value={project.id}
                                            checked={formData.projectIds.includes(project.id as string)}
                                            onChange={(event)=>onProjectCheckChanged(event, project.id as string)}  />} label={project.name} />
                                    ))}
                                </CFormGroup>
                                {hasValue(formDataValidationMessages.projectIds) && <CBody2 color={"error"}>
                                    {formDataValidationMessages.projectIds}
                                </CBody2>}
                            </CGrid>
                        </CGrid>
                    </CDialogContent>

                    {(isAdding) ?
                        <CDialogActions sx={{alignItems: 'center', justifyContent: 'center'}}>
                            <CCircularProgress sx={{mb: 1}}/>
                        </CDialogActions> : <CDialogActions sx={{mb: 1}}>
                            <CButton onClick={closeAddDialog}>Cancel</CButton>
                            <CButton size="medium" variant="contained" onClick={add}>Add</CButton>
                        </CDialogActions>}
                </CDialog>

                <CDialog PaperProps={{
                    style: {
                        borderRadius: 27,
                    }
                }}
                         componentsProps={{
                             backdrop: {
                                 style: {
                                     backdropFilter: "blur(3px)",
                                     backgroundColor: 'rgba(0,0,30,0.4)'
                                 }
                             },
                         }} open={updateDialog.isOpen} onClose={closeUpdateDialog} fullWidth>
                    <CDialogTitle fontWeight={"700"} sx={{mb: 2}}>Update Staff</CDialogTitle>
                    <CDialogContent>
                        <CGrid container spacing={4}>
                            <CGrid item xs={12} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <CTextField
                                    fullWidth
                                    error={hasValue(updateFormDataValidationMessages.name)}
                                    helperText={updateFormDataValidationMessages.name}
                                    label="Name"
                                    variant="standard"
                                    sx={{
                                        mb: 2
                                    }}
                                    value={updateFormData.name}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        setUpdateFormData({
                                            ...updateFormData,
                                            name: event.target.value
                                        });
                                    }}
                                />
                            </CGrid>
                            <CGrid item xs={12} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <CFormControl variant="standard" fullWidth>
                                    <CInputLabel id="role-label">Role</CInputLabel>
                                    <CSelect
                                        labelId="role-label"
                                        id="role"
                                        value={updateFormData.role}
                                        label="Role"
                                        onChange={(event: SelectChangeEvent<unknown>) => {
                                            setUpdateFormData({
                                                ...updateFormData,
                                                role: event.target.value as string
                                            });
                                        }}
                                    >
                                        <CMenuItem value={"owner"}>Owner</CMenuItem>
                                        <CMenuItem value={"editor"}>Editor</CMenuItem>
                                    </CSelect>
                                </CFormControl>
                            </CGrid>
                            <CGrid item xs={12} sx={{alignItems: 'center'}}>
                                <CBody1 fontWeight={"bold"} sx={{mb: 1}}>
                                    Allowed Projects:
                                </CBody1>
                                <CFormGroup>
                                    {projects?.map(project=>(
                                        <CFormControlLabel key={project.id} control={<CCheckbox
                                            checked={updateFormData.projectIds.includes(project.id as string)}
                                            onChange={(event)=>updateOnProjectCheckChanged(event, project.id as string)}  />} label={project.name} />
                                    ))}
                                </CFormGroup>
                                {hasValue(updateFormDataValidationMessages.projectIds) && <CBody2 color={"error"}>
                                    {updateFormDataValidationMessages.projectIds}
                                </CBody2>}
                            </CGrid>
                        </CGrid>
                    </CDialogContent>

                    {(isUpdating) ?
                        <CDialogActions sx={{alignItems: 'center', justifyContent: 'center'}}>
                            <CCircularProgress sx={{mb: 1}}/>
                        </CDialogActions> : <CDialogActions sx={{mb: 1}}>
                            <CButton onClick={closeUpdateDialog}>Cancel</CButton>
                            <CButton size="medium" variant="contained" onClick={update}>Update</CButton>
                        </CDialogActions>}
                </CDialog>

                <CDialog
                    maxWidth={"xs"}
                    PaperProps={{
                        style: {
                            borderRadius: 27,
                        }
                    }}
                    componentsProps={{
                        backdrop: {
                            style: {
                                backdropFilter: "blur(3px)",
                                backgroundColor: 'rgba(0,0,30,0.4)'
                            }
                        },
                    }} open={deleteDialog.isOpen} onClose={closeDeleteDialog} fullWidth>
                    <CDialogTitle fontWeight={"700"} sx={{mb: 2}} color={"error"}>Delete User</CDialogTitle>
                    <CDialogContent>
                        <CGrid container spacing={2}>
                            <CGrid item xs={12} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <CBody1>
                                    After deleting this staff they won't be able to access your Abeld panel any more.
                                </CBody1>
                            </CGrid>
                        </CGrid>
                    </CDialogContent>

                    {(isDeleting) ? <CDialogActions sx={{alignItems: 'center', justifyContent: 'center'}}>
                        <CCircularProgress sx={{mb: 1}}/>
                    </CDialogActions> : <CDialogActions sx={{mb: 1}}>
                        <CButton onClick={closeDeleteDialog}>Cancel</CButton>
                        <CButton color={"error"} size="medium" variant="contained" onClick={submitDelete}>Delete</CButton>
                    </CDialogActions>}
                </CDialog>
            </>
        );
    }
)
